import {styled} from '@linaria/react';
import React from 'react';
import {FONT_SIZES} from '../../../../constants/typography';
import {SectionFooter} from '../SectionFooter';
import {SectionHeadline} from '../SectionHeadline';

interface LinksGridContainerProps {
  children: React.ReactNode;
  className?: string;
  footer?: {label: string; url: {url: string}};
  headline?: string;
  onLinkItemClick: () => void;
}

export const LinksGridContainer: React.FC<LinksGridContainerProps> = ({
  children,
  className,
  footer,
  headline,
  onLinkItemClick,
}) => {
  return (
    <Wrapper className={className} $height={footer ? '100%' : 'auto'}>
      <LinksGridWrapper>
        <SectionHeadline dataTestId="linkContainerHeadline" label={headline} />
        {children}
      </LinksGridWrapper>
      {footer && (
        <SectionFooter
          label={footer.label}
          onLinkItemClick={onLinkItemClick}
          url={footer.url.url}
        />
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div<{$height: string}>`
  display: block;
  margin-right: auto;
  font-size: ${FONT_SIZES.px12};
  max-height: inherit;
  height: ${({$height}) => $height};
`;

const LinksGridWrapper = styled.div`
  max-height: inherit;
  margin-bottom: 10px;
`;
